import React from 'react'

import type { MenuContentBlock } from '@library/api-menu-experience'

import { renderContentBlocks } from './renderContentBlocks'

type CollectionScreenWrapperProps = {
  contentBlocks: MenuContentBlock[]
}

export const CollectionScreenWrapper = ({ contentBlocks }: CollectionScreenWrapperProps) => (
  <div data-testid="menu-experience-collection-screen">{renderContentBlocks(contentBlocks)}</div>
)
